import { useNavigate, useParams } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { CreateObjectWizard } from 'widgets/kyrgyzstan/create-object-wizard'

import { CreateObjectStepId } from 'entities/kyrgyzstan/model/create-object'

const KyrgyzstanCreateObjectPage = () => {
  const navigate = useNavigate()
  const { stepId } = useParams<{ stepId: string }>() as { stepId: string }

  const handleOpenStep = (stepId: CreateObjectStepId) => {
    navigate(RoutingPaths.kyrgyzstan.objects.create.step.path(stepId), {
      replace: true,
    })
  }

  const handleSubmitted = () => {
    navigate(RoutingPaths.kyrgyzstan.objects.create.submitted.path())
  }

  const handleExit = () => {
    navigate(-1)
  }

  return (
    <CreateObjectWizard
      stepId={stepId}
      onExit={handleExit}
      onOpenStep={handleOpenStep}
      onSubmitted={handleSubmitted}
    />
  )
}

export default KyrgyzstanCreateObjectPage
